export const visiblesCodes = [
  "O-0087A-MF",
  "O-0087B-MF",
  "O-0087B-MD",
  "O-0087B-MO",
  "O-0087D-MF",
];
